<script>
  import { createEventDispatcher, tick, onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import { token, peers, ui } from '../stores';
  import config from '../config';

  // This has grown organically into a bit of a mess. Needs to be refactored.

  let videoEl, showVideo, tokenEl, headlightsEl;

  const dispatch = createEventDispatcher();
  const collisionDistance = 5;

  onMount(() => {
    updatePosition($token.x, $token.y);
  });

  let doubleClick;
  async function displayVideoBriefly() {
    if (doubleClick) return;
    doubleClick = true;
    showVideo = true;
    // we need to wait until <video> element is rendered
    // console.log('$token.stream:', $token.stream);
    await tick();
    videoEl.srcObject = $token.stream;
    setTimeout(() => {
      // showVideo = false;
      // doubleClick = null;
    }, 4000);
  }

  let borderColor;
  $: borderColor = $token.clusterId
    ? $ui.theme.circle.borderColorActive
    : $ui.theme.circle.borderColor;

  $token = {
    ...$token,
    angle: 0,
    speed: 0.5,
    rotationSpeed: 4,
    isMoving: false,
    isRotating: false,
    headlightsAreOn: false,
  };

  function rotate(direction) {
    if (!tokenEl) return;
    $token.headlightsAreOn = true;
    if ($token.angle < 0) $token.angle = 360 + $token.angle;
    if ($token.angle > 360) $token.angle = $token.angle - 360;
    if (direction === 'left') $token.angle -= $token.rotationSpeed;
    if (direction === 'right') $token.angle += $token.rotationSpeed;
    headlightsEl.style.transform = `rotate(${$token.angle}deg)`;
    $token.isRotating = requestAnimationFrame(() => rotate(direction));
  }

  function rotateStop() {
    cancelAnimationFrame($token.isRotating);
    $token.headlightsAreOn = false;
  }

  function moveStop() {
    cancelAnimationFrame($token.isMoving);
    $token.headlightsAreOn = false;
  }

  function getNewPosition(direction) {
    // Return newX and newY based on angle (which direction we're pointing in) and move
    // direction (forward or backward)
    // xBias value between 0 and 1 means rightward movement
    // xBias value between -1 and 0 means leftward movement
    // yBias value between 0 and 1 means downward movement
    // yBias value between -1 and 0 means upward movement
    let xBias = 0,
      yBias = 0;
    // Pointing right?
    if ($token.angle > 0 && $token.angle < 180) {
      xBias = (90 - Math.abs(90 - $token.angle)) / 90; // How close to 90 ranging 0 to 1
    }
    // Pointing left?
    else if ($token.angle > 180 && $token.angle < 360) {
      xBias = (-1 * (90 - Math.abs(270 - $token.angle))) / 90; // How close to 270 ranging 0 to 1
    }
    // Remember, xBias is strong as it gets closer to 1.0 or -1.0.
    // yBias strength is the proportional inverse of xBias but the sign depends on up or down.
    const yBiasAbs = 1 - Math.abs(xBias);
    // Pointing down?
    if ($token.angle > 90 && $token.angle < 270) {
      yBias = yBiasAbs;
    }
    // Pointing up?
    else if ($token.angle > 270 || $token.angle < 90) {
      yBias = -1 * yBiasAbs;
    }
    // Now calculate new x and y positions based on direction, speed, and x and biases
    const directionBias = direction == 'backward' ? -1 : 1;
    const x = $token.x + $token.speed * xBias * directionBias;
    const y = $token.y + $token.speed * yBias * directionBias;
    return { x, y };
  }

  function move(direction) {
    $token.headlightsAreOn = true;

    // Too far left or right?
    if ($token.x < 2.5) {
      $token.x = 2.5;
      return moveStop();
    }

    if ($token.x > 97.5) {
      $token.x = 97.5;
      return moveStop();
    }

    // Too far up or down?
    if ($token.y < 2.5) {
      $token.y = 2.5;
      return moveStop();
    }

    if ($token.y > 97.5) {
      $token.y = 97.5;
      return moveStop();
    }

    // Colliding with another peer?
    for (let peerId in $peers) {
      const peer = $peers[peerId];
      const proximity = token.getProximity(peer);
      if (proximity < collisionDistance) {
        console.log('moving away');
        console.log('before moveAway:', $token.x, $token.y);
        const { x, y } = moveAwayFromPeer(peer, collisionDistance + 0.05);
        console.log('after moveAway:', $token.x, $token.y);
        updatePosition(x, y);
        moveStop();
        return;
      }
    }

    // Okay, reposition.
    const { x, y } = getNewPosition(direction);
    updatePosition(x, y);
    $token.isMoving = requestAnimationFrame(() => move(direction));
  }

  function moveAwayFromPeer(peer, distance) {
    const radians = Math.atan2($token.y - peer.y, $token.x - peer.x);
    const x = Math.cos(radians) * distance + peer.x;
    const y = Math.sin(radians) * distance + peer.y;
    return { x, y };
  }

  async function updatePosition(x, y) {
    await tick();
    $token.x = x;
    $token.y = y;
    try {
      tokenEl.style.left = x + '%';
      tokenEl.style.top = y + '%';
      dispatch('tokenMoved', { x, y });
    } catch (error) {
      console.log(error);
    }
  }

  function handleKeys(e, action) {
    // Arrow keys
    const reservedKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
    if (reservedKeys.includes('e.key')) e.preventDefault();
    if (action === 'down' && !e.repeat) {
      switch (e.key) {
        case 'ArrowUp':
          return move('forward');
        case 'ArrowDown':
          return move('backward');
        case 'ArrowLeft':
          return rotate('left');
        case 'ArrowRight':
          return rotate('right');
      }
    } else if (action === 'up') {
      switch (e.key) {
        case 'ArrowUp':
          return moveStop();
        case 'ArrowDown':
          return moveStop();
        case 'ArrowLeft':
          return rotateStop();
        case 'ArrowRight':
          return rotateStop();
      }
    }
  }
</script>

<style type="text/postcss">
  .token {
    width: 5%;
    height: 5%;
    margin-left: -2.5%;
    margin-top: -2.5%;
    cursor: pointer;
  }
  .wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .video {
    max-width: unset;
    height: 150%;
    width: auto;
    margin-left: -25%;
    margin-top: -25%;
    border-radius: 9999px;
    border: 4px solid transparent;
  }
  .headlights {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    overflow: visible;
  }
  .beam {
    position: absolute;
    top: -200%;
    left: -50%;
    height: 200%;
    width: 200%;
    background: url("data:image/svg+xml;utf8,<svg width='418px' height='411px' viewBox='0 0 418 411' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><defs><radialGradient cx='47.6772494%' cy='241.99563%' fx='47.6772494%' fy='241.99563%' r='224.09563%' gradientTransform='translate(0.476772,2.419956),scale(0.999262,1.000000),rotate(-90.000000),scale(1.000000,1.414377),translate(-0.476772,-2.419956)' id='radialGradient-1'><stop stop-color='%23FFFFFF' offset='0%'></stop><stop stop-color='%23FFFFFF' stop-opacity='0' offset='100%'></stop></radialGradient></defs><g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><path d='M167.179663,410.63119 L-41,-89 L459,-89 L250.820337,410.63119 C237.505502,406.960726 223.481727,405 209,405 C194.518273,405 180.494498,406.960726 167.179663,410.63119 Z' id='Combined-Shape' fill='url(%23radialGradient-1)'></path></g></svg>");
    background-size: contain;
    opacity: 0.3;
  }
</style>

<svelte:window
  on:keydown="{(e) => handleKeys(e, 'down')}"
  on:keyup="{(e) => handleKeys(e, 'up')}" />

<!-- Token -->
<div
  class="token absolute overflow-visible z-50"
  on:click="{displayVideoBriefly}"
  bind:this="{tokenEl}">
  <!-- Circle -->
  <div
    class="wrapper border-4 rounded-full"
    style="background: {$ui.theme.circle.background}; border-color: {borderColor}">
    <div class="flex flex-col items-center justify-center h-full">
      <!-- Video -->
      {#if showVideo}
        <video
          bind:this="{videoEl}"
          transition:fade="{{ duration: 800 }}"
          class="video"
          autoplay
          muted
          playsinline></video>
        <!-- Snapshot (default when not in a cluster-->
      {:else if !$token.clusterId}
        <img
          style="filter: grayscale(100%)"
          alt="TOKEN"
          src="{$token.snapshot}"
          transition:fade="{{ duration: 200 }}" />
      {/if}
    </div>
  </div>

  <!-- Headlights -->
  <div class="headlights" bind:this="{headlightsEl}">
    {#if $token.headlightsAreOn}
      <div
        class="beam"
        style="opacity:{$ui.theme.circle.headlightOpacity}"
        out:fade="{{ delay: 100, duration: 200 }}"></div>
    {/if}
  </div>

  {#if config.debug.on && $token.id}
    <div class="flex flex-col items-center justify-center h-full w-full absolute inset-0 z-50">
      <h2>{$token.id.slice(-3)}</h2>
      <h2>{($token.clusterId || '---').slice(-3)}</h2>
    </div>
  {/if}
</div>
